import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-app_icon-06",
  "use": "icon-app_icon-06-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"icon-app_icon-06\"><g><path d=\"M21.5 15.5a1 1 0 01-1-1V3l.308.004C27.57 3.167 33 8.699 33 15.5z\" fill-opacity=\".6\" /><path d=\"M18 3C9.716 3 3 9.716 3 18c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15H19a1 1 0 01-1-1V3z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol